// extracted by mini-css-extract-plugin
export default {"application":"ShellUI--application__KkPPll","app-root":"ShellUI--app-root__rMKgMh","appRoot":"ShellUI--app-root__rMKgMh"};